import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/app/(core)/(home)/HomeContent.tsx");
